import { Component, OnInit, ViewChild,ElementRef } from '@angular/core';
import { LeadsService } from '../../_service/leads.service';
import { SharedService } from '../../_service/shared.service';
import { ActivatedRoute, Router  } from '@angular/router';
import { MiscService } from '../../_service/misc.service';
import {PageEvent,MatPaginator} from '@angular/material/paginator';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import {OpdModalComponent} from '../../opd/opd-modal/opd-modal.component';
import {OpdPrescriptionAuditComponent} from '../../opd/opd-prescription-audit/opd-prescription-audit.component';
import { OpdDocsStatusComponent } from '../../opd/opd-docs-status/opd-docs-status.component';
import {formatDate} from '@angular/common';
import * as XLSX from 'xlsx';
declare var $: any;
import jsPDF from 'jspdf';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
pdfMake.vfs = pdfFonts.pdfMake.vfs;
import htmlToPdfmake from 'html-to-pdfmake';
import { UserService } from 'src/app/_service/user.service';

@Component({
  selector: 'app-opds',
  templateUrl: './opds.component.html',
  styleUrls: ['./opds.component.css']
})
export class OpdsComponent implements OnInit {
 
    perpage:number=25;opds:any=[];length:number=0;pageEvent: PageEvent;loading:boolean=true;myrole:string;treatment='';lead_source='';
    pageSizeOptions = [10,25,50,100];pageIndex:number=0;bds=[];loaded:boolean=false;circles=[];circle='';userId:string;
    search:string;doctor:string;hospital:string;bd:string;start_date:string='';end_date:string='';treatments=[];
    submitted:boolean=false;doctors=[];hospitals=[];opdDetail:any={};opdCopy:string='';txt:string='Copy';sc3Url:string='';doctorFilter:boolean=true;hospitalFilter:boolean=true;bds_copy=[];doctors_copy=[];hospitals_copy=[];treatments_copy=[];status='';surgery_suggested='';feedbackStatus='';OpdID:any='';showPendingPrescription:string;lead_category_filter='';treatCategory=[];payment_mode='';lead_sources=[];isCMAccess:string;
    prescriptionAuditing='';selectAction='';prescriptionFilter='';callDeatils=[];
    opdHistoryDetail=[];billedloading:boolean=true;billedloaded:boolean=false;
    click_to_call_loading:boolean=false;response_call_id='';progression_msg='';end_to_call_btn_disable=false;feedBackUser=[];
    followup_start_date:string='';followup_end_date:string='';is_doctor_access='';
    @ViewChild('dateRangeStart', {static: false}) dateRangeStart: ElementRef;
    @ViewChild('dateRangeEnd', {static: false}) dateRangeEnd: ElementRef;
    @ViewChild('followupDateRangeStart', {static: false}) followupDateRangeStart: ElementRef;
    @ViewChild('followupDateRangeEnd', {static: false}) followupDateRangeEnd: ElementRef;
    @ViewChild('paginatorBottom', {static: false}) paginatorBottom: MatPaginator;
    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild('csvUploadShares', {static: false}) csvUploadShares: ElementRef;

    @ViewChild('pdfTable') pdfTable: ElementRef;
    
    constructor(private leadapi:LeadsService,private sharedapi:SharedService,private dialog:MatDialog,private activatedRoute: ActivatedRoute,public miscapi:MiscService,private userapi:UserService,public router: Router) {
        this.activatedRoute.params.subscribe(params => {
            if (params['doctor_id']) {
                this.doctor = params['doctor_id'];
                this.doctorFilter=false;
            }else if (params['hospital_id']) {
                this.hospital = params['hospital_id'];
                this.hospitalFilter=false;
            }
        });
     }

    public downloadAsPDF() {
        const doc = new jsPDF();
       
        const pdfTable = this.pdfTable.nativeElement;
       
        var html = htmlToPdfmake(pdfTable.innerHTML);
         
        const documentDefinition = { content: html };
        pdfMake.createPdf(documentDefinition).download('OPD_'+this.OpdID+'.pdf'); 
         
    }



    ngOnInit(): void 
    {
        this.getbds();this.getcircle();
        this.getTreatment();this.getTreatmentCategory();
        this.getDoctor();this.getHospital();
        this.sharedapi.getRole()
        this.sharedapi.getRole().subscribe((item:string) => {this.myrole=item;});
        this.myrole = localStorage.getItem('role');
        this.userId = localStorage.getItem('loginuserId');
        this.sc3Url= localStorage.getItem('s3url');
        this.isCMAccess = localStorage.getItem('CMAccess');
        this.is_doctor_access = localStorage.getItem('is_doctor_access');
        if(this.myrole=='13'){
            this.lead_source='24';
        }
        this.getLeadSources();
        if(this.myrole == '1' || (this.myrole=='4' && this.isCMAccess=='1')) this.getFeedBackUser();

        if(this.myrole=='16'){
            this.router.navigateByUrl('dashboard');
        }
    }

    ngAfterViewInit() {
         this.loadOpds(0,this.perpage);
    }

    resetFilters(){
        this.clearDate();
        this.search = ''; this.bd = '';this.circle = '';this.doctor = '';this.hospital = '';this.treatment = '';this.status = '';this.lead_source = '';this.payment_mode = '';this.feedbackStatus = '';this.lead_category_filter = '';this.surgery_suggested= ''; this.showPendingPrescription = '';this.prescriptionAuditing='';this.selectAction='';this.prescriptionFilter='';
        this.clearFollowupDate();
       
        this.loadOpds(0,25);
    }

    setSearchValue(type){
        if(type=='lead_owner'){
            $("#ownerSearch").val('');
            $("#ownerSearch").focus();
            this.bds= this.bds_copy;
        }else if(type=='doctor'){
            $("#doctorSearch").val('');
            $("#doctorSearch").focus();
            this.doctors= this.doctors_copy;
        }else if(type=='hospital'){
            $("#hospitalSearch").val('');
            $("#hospitalSearch").focus();
            this.hospitals= this.hospitals_copy;
        }else if(type=='treatment'){
            $("#treatmentSearch").val('');
            $("#treatmentSearch").focus();
            this.treatments= this.treatments_copy;
        }
    }

    searchOnSelect(searchtText: string, type){
        if(type == 'lead_owner'){
             this.bds = this.sharedapi.searchData(searchtText, this.bds_copy, "name");
        }else if(type == 'doctor'){
            this.doctors = this.sharedapi.searchData(searchtText, this.doctors_copy, "name");
        }else if(type == 'hospital'){
            this.hospitals = this.sharedapi.searchData(searchtText, this.hospitals_copy, "name");
        }else if(type == 'treatment'){
            this.treatments = this.sharedapi.searchData(searchtText, this.treatments_copy, "name");
        }
    }


    async loadOpds(pageIndex,perpage)
    {
        this.opds = [];
        this.paginator.pageIndex = pageIndex; 
        this.paginatorBottom.pageIndex = pageIndex;
        this.pageIndex = pageIndex;
        let qString = 'hospital='+this.hospital+'&doctor='+this.doctor+'&search='+this.search+'&circle='+this.circle+'&treatment='+this.treatment+'&bd='+this.bd+'&date_range='+this.start_date+'-'+this.end_date+'&status='+this.status+'&pendingPrescription='+this.showPendingPrescription+'&surgery_suggested='+this.surgery_suggested+'&feedbackStatus='+this.feedbackStatus+'&lead_source='+this.lead_source+'&lead_category_filter='+this.lead_category_filter+'&payment_mode='+this.payment_mode+'&prescriptionAuditing='+this.prescriptionAuditing+'&selectAction='+this.selectAction+'&prescriptionFilter='+this.prescriptionFilter+'&followup_date_range='+this.followup_start_date+'-'+this.followup_end_date;
        this.loading = true;this.loaded = false;
        await this.leadapi.getOpds(this.paginator.pageIndex,perpage,qString).subscribe((data:any) => {
            this.length = parseInt(data.totaldata);
            this.loading = false;
            this.loaded = true;
            if(data.status)
            {
                this.opds = data.data;
            }else{
                this.opds = [];
            }
        }, error => {
            this.loading = false;
            this.loaded = true;
            this.sharedapi.checkError(error);
        });
    }

    pageChange(event)
    {
        this.pageIndex = event.pageIndex;
        this.loadOpds(event.pageIndex,event.pageSize);
    }

    public getServerData(event:PageEvent):any
    {
        this.perpage = event.pageSize;
        this.pageIndex = event.pageIndex;
        this.loadOpds(event.pageIndex,event.pageSize);
    }

    async getbds()
    {
        await this.leadapi.getbds().subscribe((data:any) => {
            if(data.status)
            {
                this.bds = data.data;
                this.bds_copy= this.bds;
            }else{
                this.bds = [];
            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }
    
    async getcircle()
    {
        await this.leadapi.getcircles().subscribe((data:any) => {
            if(data.status)
            {
                this.circles = data.data;
            }else{
                this.circles = [];
            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }

    async getTreatment()
    {
        await this.leadapi.getTreatments().subscribe((data:any) => {
            if(data.status)
            {
                this.treatments = data.data;
                this.treatments_copy= this.treatments;
            }else{
                this.treatments = [];
            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }
    async getTreatmentCategory()
    {
        await this.miscapi.getTreat_Category().subscribe((data:any) => {
            if(data.status)
            {
                this.treatCategory = data.data;
            }else{
                this.treatCategory = [];
                this.sharedapi.presentToast(data.msg);
            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }
    
    async getDoctor()
    {
        await this.leadapi.getdoctors().subscribe((data:any) => {
            if(data.status)
            {
                this.doctors = data.data;
                this.doctors_copy= this.doctors;
            }else{
                this.doctors = [];
            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }
    
    async getHospital()
    {
        await this.leadapi.gethospitals().subscribe((data:any) => {
            if(data.status)
            {
                this.hospitals = data.data;
                this.hospitals_copy= this.hospitals;
            }else{
                this.hospitals = [];
            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }
    
    dateRangeChange(date1,date2)
    {
        if(date2.value)
        {
            this.start_date = date1.value;
            this.end_date = date2.value;
            //this.loadOpds(0,this.perpage);
        }
    }
    
    clearDate()
    {
        this.dateRangeStart.nativeElement.value = "";
        this.dateRangeEnd.nativeElement.value = "";
        this.start_date = '';
        this.end_date = '';
        //this.loadOpds(0,this.perpage);
    }

    openOpdDialog(lead_id)
    {
        const dialogRef = this.dialog.open(OpdModalComponent, {
            width: '100%',
            height: '90%',
            data:{lead_id:lead_id}
        });

        dialogRef.afterClosed().subscribe(result => {
            console.log(result);
        });
    }

    openPrescriptionAuditingDialog(lead_id)
    {
        const dialogRef = this.dialog.open(OpdPrescriptionAuditComponent, {
            width: '100%',
            height: '90%',
            data:{lead_id:lead_id}
        });

        dialogRef.afterClosed().subscribe(result => {
            console.log(result);
        });
    }

    async getLeadSources()
    {
        this.leadapi.getLeadSources().subscribe((data:any) => {
            if(data.status)
            {
                this.lead_sources = data.data;
            }else{
                this.lead_sources = [];
            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }
  
    
    async markStatus(opd_id,status)
    {
        let msg = 'Complete';
        if(status==3)
        msg = 'Cancel';
        if(confirm("Do you want to "+msg+" this OPD?"))
        {
            await this.leadapi.changeStatus(opd_id,status).subscribe((data:any) => {
            this.sharedapi.presentToast(data.msg);
            this.loadOpds(this.pageIndex,this.perpage);
        }, error => {
            this.sharedapi.checkError(error);
        });
        }
    }

    /* async sendOpdReviewLink(opd_id)
    {
        if(confirm("Do you want to send review link to customer of this OPD?"))
        {
            await this.leadapi.sendOpdReviewLink(opd_id).subscribe((data:any) => {
                this.sharedapi.presentToast(data.msg);
                this.loadOpds(this.pageIndex,this.perpage);
            }, error => {
                this.sharedapi.checkError(error);
            });
        }
    } */
    
    hideModal()
    {
        $('#myModal').modal('hide');
    }
    
    async viewOpd(opd_id)
    {
        this.OpdID= opd_id;
        this.txt='Copy';
        $('#myModal').modal();
        await this.leadapi.viewOpdDetails(opd_id).subscribe((data:any) => {
            if(data.status)
            {
                this.opdDetail = data.data;
                let appointment_date = formatDate(data.data.appointment_time*1000, 'dd MMM, yyyy', 'en-US');
                let appointment_time = formatDate(data.data.appointment_time*1000, 'hh:mm aa', 'en-US');
                this.opdCopy = "*Patient Name :* "+data.data.patient+" \n\n*Medical Counsellor :* "+data.data.bd_name+"\n\n*Doctor Name :* "+data.data.doctor_name+"\n\n*Treatment :* "+data.data.treatment_name+"\n\n*Hospital Name :* "+data.data.hospital_name+"\n\n*Address :* "+data.data.address+"\n\n*Location :* "+data.data.location+"\n\n*Appointment Date :* "+appointment_date+"\n\n*Appointment Time at the center :* "+appointment_time+"\n\n*Fee :* "+data.data.billed_amt+"\n\n*Regards Glamyo Health*";
            }else{
                this.opdDetail = {};
            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }
    
    getSurgerySuggested(surgeryS)
    {
        let surgery = 'Pending';
        switch(surgeryS)
        {
            case 0:
            surgery = 'Pending';
            break;
            case 1:
            surgery = 'Yes';
            break;
            case 2:
            surgery = 'No';
            break;
        }
        return surgery;
    }
    
    exportOpdList()
    {
        if(this.opds.length>0)
        {
            let data = [];

            let titles = ['Lead Id','Surgery Suggested','Medical Officer Action Status','Appointment Id','Glamyo Patient Id','Glamyo Appointment Id','Lead Status','Patient Name','Patient Age','Circle','Lead Owner','Employee Id','Treatment','Treatment Catergory','Doctor','Hospital','Consultation Type','Appointment Time','Payment Mode','Consultation Fee','Status','Created Date','Prescription Link','Campaign Name','Keywords','AD Group Id','Match Type','Form Lead Source'];

            if(this.myrole=="1")
            {
                titles.push(
                    'Patient Mobile',
                    'Audit Surgery Suggest',
                    'Audit Prescription Status',
                    'Audit Name',
                    'Audit Age',
                    'Audit Gender',
                    'Audit Date',
                    'Audit Signature',
                    'Audit Medication Advised',
                    'Audit Medication Advised Days',
                    'Audit History Mentioned',
                    'Audit Investigations',
                    'Audit Surgery Date',
                );
            }

            data.push(titles);
            for(let key in this.opds)
            {
                let prescription = 'Not Uploaded';
                if(this.opds[key].prescription_link.length)
                prescription = this.sc3Url+this.opds[key].prescription_link[0].links;
                let consultType='';
                if(this.opds[key].consultation_type==1){
                    consultType = 'Online Consultation';
                }else if(this.opds[key].consultation_type==2){
                    consultType = 'Offline Consultation';
                }
                let approvedStatus = '';
                if(this.opds[key].approved_status==1){
                    approvedStatus = 'Approved';
                }else if(this.opds[key].approved_status==2){
                    approvedStatus = 'Rejected';
                }else if(this.opds[key].approved_status==3){
                    approvedStatus = 'Approved with High Risk';
                }
                let glamyoPatientId = 'GHOPD'+this.opds[key].id;
                let exdata = [this.opds[key].lead_id,this.getSurgerySuggested(this.opds[key].surgery_suggested),approvedStatus,               
                this.opds[key].appointment_id,this.opds[key].glamyo_patient_id,glamyoPatientId,this.opds[key].source_name,this.opds[key].patient,this.opds[key].patient_age,this.opds[key].circle_name,this.opds[key].bd_name,this.opds[key].employee_id,this.opds[key].treatment_name,this.opds[key].treatment_categoriesName,this.opds[key].doctor_name,this.opds[key].hospital_name,consultType,
                formatDate(this.opds[key].appointment_time*1000, 'dd MMM, yyyy hh:mm aa', 'en-US'),this.opds[key].payment_mode,this.opds[key].billed_amt,this.sharedapi.getStatus(this.opds[key].status),formatDate(this.opds[key].created_at*1000, 'dd MMM, yyyy hh:mm aa', 'en-US'),prescription,
                this.opds[key].campaign_name,
                this.opds[key].keywords,
                    this.opds[key].utm_agid,
                    this.opds[key].matchtype,
                    this.opds[key].zoho_lead_source
                ];

                

                if(this.myrole=="1")
                {
                    exdata.push(
                        this.opds[key].phone,
                        this.opds[key].pres_audit_surgery_suggest,
                        this.opds[key].pres_audit_prescription_status,
                        this.opds[key].pres_audit_name,
                        this.opds[key].pres_audit_age,
                        this.opds[key].pres_audit_gender,
                        this.opds[key].pres_audit_date,
                        this.opds[key].pres_audit_signature,
                        this.opds[key].pres_audit_medication_advised,
                        this.opds[key].pres_audit_medication_advised_days,
                        this.opds[key].pres_audit_history_mentioned,
                        this.opds[key].pres_audit_history_investigations,
                        this.opds[key].pres_audit_surgery_date
                    );
                }
               
                data.push(exdata);
            }
            let ws = XLSX.utils.aoa_to_sheet(data);
           /* generate workbook and add the worksheet */
           const wb: XLSX.WorkBook = XLSX.utils.book_new();
           XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

           /* save to file */
           let utc = new Date().toJSON().slice(0,10).replace(/-/g,'/');
           XLSX.writeFile(wb, 'opd_'+utc+'.xlsx');
        }else{
            this.sharedapi.presentToast('OPD not found!');
        }
    }

    
    async viewopdHistory(opd_id)
    {
        this.opdHistoryDetail=[];
        $('#BilledModal').modal();
        this.billedloading = true;this.billedloaded = false;
        await this.leadapi.viewOpdHistroyDetails(opd_id).subscribe((data:any) => {
            if(data.status)
            {
               this.billedloading = false;this.billedloaded = true;
               this.opdHistoryDetail=data.data;

            }else{
                this.billedloading = false;this.billedloaded = true;
                this.opdHistoryDetail = [];

            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }

    hideHistroyModal()
    {
        $('#BilledModal').modal('hide');
    }

    
    click_to_call_function(lead_id)
    {
        this.click_to_call_loading = true;
        let lead_id_arr = {'lead_id': lead_id};
        this.leadapi.OpdIpdClickTOCall(lead_id_arr).subscribe((data:any) => {
            this.click_to_call_loading = false;
            console.log(data);
            if(data.status){
                this.response_call_id = data.call_id;
                $("#click_to_call_progress").modal("show");
            } else {
                this.sharedapi.presentToast(data.msg);
            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }

    endClicktoCall()
    {
        this.progression_msg = "";
        this.end_to_call_btn_disable = true;
        if(this.response_call_id)
        {
            let lead_id_arr = {'response_call_id': this.response_call_id};
            this.leadapi.endClicktoCall(lead_id_arr).subscribe((data:any) => {
                this.end_to_call_btn_disable = false;
                $('#click_to_call_progress').modal('hide');
            }, error => {
                this.sharedapi.checkError(error);
            });
        } else {
            this.sharedapi.checkError("Please reload the page. Something went to wrong.");
        }
        
    }
    async call_details(lead_id)
    {
        await this.leadapi.getIpdOpdCallDetails(lead_id).subscribe((data: any) => {
            if (data.status) {
                $("#opd_call_details").modal("show");
              this.callDeatils = data.data;
            } else {
              this.callDeatils = [];
            }
          }, error => {
            this.sharedapi.checkError(error);
          });
    }

    closeCallDetailsModal(){
        $('#opd_call_details').modal('hide');

    }

    copyMessage(text: string) {
        this.sharedapi.presentToast('Link copied to clipboard.');
        navigator.clipboard.writeText(text).then().catch(e => console.log(e));
      }

    updateAssignee(userId: number, opdId: number)
    {
        this.leadapi.updateOpdAssignee(userId, opdId).subscribe((data:any) => {
            if(data.status) {
                this.sharedapi.presentToast(data.msg);
                this.loadOpds(this.pageIndex,this.perpage);
            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }

    getFeedBackUser(status=1)
    {
        this.leadapi.getFeedbackUsers(status).subscribe((data:any) => {
        if(data.status)
        {
            this.feedBackUser = data.data;
        }else{
            this.feedBackUser = [];
        }
          }, error => {
              this.sharedapi.checkError(error);
          });
      }

      followupDateRangeChange(date1,date2)
    {
        if(date2.value)
        {
            this.followup_start_date = date1.value;
            this.followup_end_date = date2.value;
        }
    }

    clearFollowupDate()
    {
        this.followupDateRangeStart.nativeElement.value = "";
        this.followupDateRangeEnd.nativeElement.value = "";
        this.followup_start_date = '';
        this.followup_end_date = '';
    }

    showModalGlamyoShares()
    {
        $('#myModalGlamyoShares').modal();
    }
  
    hideModalGlamyoShares()
    {
        $('#myModalGlamyoShares').modal('hide');
    }
  
    async selectFileOpdShare(event)
    {
        this.submitted = true;
        let file = event.target.files.item(0);
        const formData = new FormData();
        formData.append('file', file);
        this.leadapi.uploadOpdSharesCsv(formData)
        .subscribe((data:any) => {
            this.submitted = false;
            this.csvUploadShares.nativeElement.value = "";
            if(data.status)
            {
                this.hideModalGlamyoShares();
                this.sharedapi.presentToast(data.msg);
                this.loadOpds(0, this.perpage);
            }
            else
            {
                this.sharedapi.presentToast(data.msg);
            }
          }, error =>
            {
                this.sharedapi.checkError(error);
            });
    }
}
